/**
 * `'ontouchstart' in window` alone misses some real touch hardware (notably hybrid
 * Windows laptops/tablets where a mouse is the primary pointer but a touchscreen is
 * also present). Combine it with maxTouchPoints and an any-pointer media check so
 * touch controls actually appear on every touch-capable device, not just the ones
 * that report the classic touch-events API.
 */
export const isTouchDevice: boolean =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  (typeof window.matchMedia === 'function' && window.matchMedia('(any-pointer: coarse)').matches);
